import React from 'react';
import { volumeIncludes, volumes } from '../data/content';
export function Volumes() {
  return <section className="w-full bg-white px-5 py-16 sm:px-8" data-id="element-285" data-mp="1lvthlzuwx1ab">
      <div className="mx-auto w-full max-w-6xl" data-id="element-286" data-mp="1lx4oi8jnmp5n">
        <h2 className="text-center text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl md:text-5xl" data-id="element-287" data-mp="184wuupno3eb6">
          The 6 Complete Volumes
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-288" data-mp="1zv1l34y3yvkb">
          {volumes.map(volume => <article key={volume.label} className="flex h-full flex-col rounded-2xl border border-neutral-200 bg-white p-6" data-id="element-289" data-mp="24unzvitl4jv8">
              <div className="flex items-start gap-3" data-id="element-290" data-mp="1qwhdayu366av">
                <span aria-hidden="true" className="text-xl leading-none" data-id="element-291" data-mp="1vsesv2xiz8ml">
                  {volume.dot}
                </span>
                <div data-id="element-292" data-mp="fdwow95s00gv">
                  <p className="text-xs font-extrabold uppercase tracking-[0.1em] text-neutral-900" data-id="element-293" data-mp="keay3uj45ggh">
                    {volume.label}
                  </p>
                  <h3 className="mt-1 text-lg font-extrabold leading-snug text-ember" data-id="element-294" data-mp="3o8yaz2zluppd">
                    {volume.title}
                  </h3>
                </div>
              </div>
              <p className="mt-4 text-sm font-bold text-neutral-900" data-id="element-295" data-mp="21zwrrlguw0m">
                {volume.highlight}
              </p>
              <p className="mt-auto pt-4 text-sm leading-relaxed text-neutral-600" data-id="element-296" data-mp="3t5opvmzobf97">
                {volume.detail}
              </p>
            </article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-neutral-200 bg-neutral-50 px-6 py-8" data-id="element-297" data-mp="61saeippvscu">
          <p className="text-center text-xs font-bold uppercase tracking-[0.18em] text-neutral-900" data-id="element-298" data-mp="kqeoyi7isg30">
            What every volume includes
          </p>
          <ul className="mx-auto mt-6 grid max-w-3xl gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-299" data-mp="ts4fzmxhpd09">
            {volumeIncludes.map(item => <li key={item} className="flex items-center gap-2 text-sm font-bold text-neutral-900" data-id="element-300" data-mp="prkj8kgtwben">
                <span aria-hidden="true" data-id="element-301" data-mp="wrwgtgl2b4t2">✅</span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}